import React from "react";
import { useDeviceType } from "../../../customHooks/useDeviceType";
import { Button, SvgIconHandler } from "../../../atoms";
import "./subscription-success.m.css";

export function SubscriptionSuccess() {
  const isMobile = useDeviceType() !== "desktop";
  const svgDimension = isMobile ? { width: 64, height: 64 } : { width: 88, height: 88 };

  return (
    <div styleName="container">
      <div styleName="message-section">
        <div>
          <SvgIconHandler type="success-circle" width={svgDimension.width} height={svgDimension.height} />
        </div>
        <div>
          <h1 styleName="title">Thank you for placing your order!</h1>
          <p styleName="description">
            Your subscription has been activated successfully! Enjoy uninterrupted browsing on OPEN across all your devices.
          </p>
        </div>
      </div>
      <div styleName="action-buttons">
        <Button
          href={`/?toastMessage=${encodeURIComponent("You have successfully Subscribed!")}`}
          customStyleName="bg-brand-primary"
        >
          Go to Home
        </Button>
        <Button href="/profile" customStyleName="">
          Go to Profile
        </Button>
      </div>
    </div>
  );
}
